/**
 *
 * Copyright (c) 2019-present, wobe-systems GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * to be found in the LICENSE file in the root directory of this source tree.
 */

import {
  httpClient, BASE_URL, PORTS, SERVICES, PATH_EXTENSION,
} from '@/middlewares/httpClient';
import { User } from './models';

const key: string = 'userservice';
const port: string = PORTS.get(key);
const service: string = SERVICES.get(key);

const END_POINT_MANAGER: string = `${BASE_URL}:${port}${PATH_EXTENSION}/${service}`;

const signupUser = (user: User, token: string) => httpClient.post(`${END_POINT_MANAGER}/signup?id=${token}`, {
  username: user.username,
  email: user.email,
  password: user.password,
});

const loginUser = (user: User) => httpClient.post(`${END_POINT_MANAGER}/login`, {
  username: user.username,
  email: user.email,
  password: user.password,
});

const updateUser = (user: User) => httpClient.put(`${END_POINT_MANAGER}/users/${user.id}`, {
  id: user.id,
  username: user.username,
  email: user.email,
  password: user.password,
});

const changePassword = (oldPassword: string, user: User) => httpClient.put(`${END_POINT_MANAGER}/changepassword/`, {
  old_password: oldPassword,
  user: {
    id: user.id,
    username: user.username,
    email: user.email,
    password: user.password,
  },
});

const requestResetPassword = (email: string) => httpClient.get(`${END_POINT_MANAGER}/resetpassword?email=${email}`);

const resetPassword = (token: string, password: string) => httpClient.post(`${END_POINT_MANAGER}/resetpassword?id=${token}`, {
  password,
});

const deleteUser = (user: User) => httpClient.delete(`${END_POINT_MANAGER}/users/${user.id}`, {
  data: {
    id: user.id,
    username: user.username,
    email: user.email,
    password: user.password,
  },
});

const logoutUser = () => httpClient.get(`${END_POINT_MANAGER}/logout`);

const fetchLoggedInUser = () => httpClient.get(`${END_POINT_MANAGER}/authentication`);

const fetchUsers = () => httpClient.get(`${END_POINT_MANAGER}/users`);

const fetchUser = (id: string) => httpClient.get(`${END_POINT_MANAGER}/users/${id}`);

const setAdminRight = (id: string) => httpClient.put(`${END_POINT_MANAGER}/users/${id}/rights/admin`);
const unsetAdminRight = (id: string) => httpClient.delete(`${END_POINT_MANAGER}/users/${id}/rights/admin`);

const setUploadRight = (id: string) => httpClient.put(`${END_POINT_MANAGER}/users/${id}/rights/upload`);
const unsetUploadRight = (id: string) => httpClient.delete(`${END_POINT_MANAGER}/users/${id}/rights/upload`);

const signupRequest = (email: string) => httpClient.post(`${END_POINT_MANAGER}/signupRequest?email=${email}`);

const verifySignupRequest = (token: string) => httpClient.get(`${END_POINT_MANAGER}/signupRequest?token=${token}`);

const changeEmailReqest = (token: string) => httpClient.post(`${END_POINT_MANAGER}/users/changeEmail/${token}`);

const sendMessageToAllUsers = (id: string, subject: string, message: string) => httpClient.put(`${END_POINT_MANAGER}/users/${id}/sendtoall/`, { subject, message });

export {
  signupUser,
  loginUser,
  logoutUser,
  fetchLoggedInUser,
  updateUser,
  changePassword,
  deleteUser,
  fetchUser,
  fetchUsers,
  setAdminRight,
  setUploadRight,
  unsetAdminRight,
  unsetUploadRight,
  requestResetPassword,
  resetPassword,
  signupRequest,
  verifySignupRequest,
  changeEmailReqest,
  sendMessageToAllUsers,
};
